import { IFrontendServiceContainer } from '@phi/frontend/service-container';
import { SelectASubscription } from '../components';
import { h } from 'vue';

export const show_select_a_subscription_page_factory = (app: IFrontendServiceContainer) => () => {
    app.pop_under_with_router.show_pop_under(true);
    app.pop_under_with_router.goto((route) => h(SelectASubscription, { app, route }));
};
